/*eslint-disable*/
import { useState } from "react";
import { toast } from 'react-toastify';
import { fetchApplications } from '../../../../../../../../services/groups';
import { isSuperAdmin } from "../../../../../../../../helpers/user";

const useApplications = (searchText) => {
    const [applications, setApplications] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const getApplications = async () => {
        try {
         if (!isSuperAdmin()) return
          setIsLoading(true)
          const response = await fetchApplications(searchText)
          const apps = response?.data?.resources.map((application) => application.label)
          setApplications(apps);
          if (apps.length === 0) {
            toast.error('No matching records found, please modify your search and try again')
          }
          setIsLoading(false)
        } catch (error) {
          setIsLoading(false)
        }
      }
    return {
        applications,
        areApplicationsLoading: isLoading,
        getApplications,
    };
}

export default useApplications;